import { PropsWithChildren } from 'react'
import { SsrContext, type SsrContextType } from './SsrContext'

export const SsrContextProvider = ({
  isMobileUA,
  children,
}: PropsWithChildren<SsrContextType>) => {
  return (
    <SsrContext.Provider value={{ isMobileUA }}>{children}</SsrContext.Provider>
  )
}
